// extracted by mini-css-extract-plugin
export var textInput = "_jb-0";